import { ReadonlySignal, computed } from "@preact/signals-core";
import { IMenuItem, MenuItemType } from "dots-ui/dotsMenuBar";
import { useCallback, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getVerticalBarMenuItems } from "../../../../data/verticalBarMenuItems";
import { LicenseesUtils } from "../../../../utils";
import { AvisContext } from "../../context/AvisContext";
import { Layout } from "./";
import { HorizontalMenuItems } from "./menuItems/HorizontalMenuItems";

export function LayoutLicensees() {
  const location = useLocation();
  const navigate = useNavigate();
  const { portalKind, logout, res } = useContext(AvisContext);

  const getUrl = (url?: string) => {
    if (!url) return;

    const urlParams = LicenseesUtils.getUrlParams();
    return LicenseesUtils.getUrlWithParams(url, urlParams);
  };

  const mapMenuItems = useCallback(
    (data?: IMenuItem[]): IMenuItem[] | undefined => {
      if (!data) return;

      const result: IMenuItem[] = [];

      data.forEach((item) => {
        const url = getUrl(item.url);
        result.push({
          ...item,
          command: url ? () => navigate(url) : null,
          items: mapMenuItems(item.items),
          url: url,
        } as IMenuItem);
      });

      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate],
  );
  const mappedItems = useMemo(
    () => mapMenuItems(getVerticalBarMenuItems(location.pathname)),
    [location.pathname, mapMenuItems],
  );

  const verticalMenuItems: IMenuItem[] = useMemo(() => {
    const items = [];

    if (mappedItems) items.push(...mappedItems);

    return items;
  }, [mappedItems]);

  const horizontalMenuItems: ReadonlySignal<MenuItemType[]> = computed(() =>
    HorizontalMenuItems(verticalMenuItems, logout, navigate, res, portalKind),
  );

  return (
    <Layout
      horizontalMenuItems={horizontalMenuItems.value}
      verticalMenuItems={verticalMenuItems}
    />
  );
}
